const autoNgTemplateLoaderTemplate1 = require('./ldap-settings-openldap.html');

import controller from './ldap-settings-openldap.controller';

export const ldapSettingsOpenLdap = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    settings: '=',
    tlscaCert: '=',
    state: '=',
    connectivityCheck: '<',

    onTlscaCertChange: '<',
    onSearchUsersClick: '<',
    onSearchGroupsClick: '<',
    onSaveSettings: '<',
    saveButtonState: '<',
    saveButtonDisabled: '<',
  },
};
